import { FC } from 'react'

import styled from 'styled-components'

import { NoDataMessage } from 'src/Components/NoDataMessage'
import { TableLoading } from 'src/Components/TableLoading'
import { ModelType } from 'src/Redux/api/modelTypesApi.ts'
import { ModelTypeItem } from 'src/Pages/TransportSettingsPage/ModelTypeItem.tsx'

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  height: 80%;
`

const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
`

interface TransportTableProps {
  modelsTypes?: Array<ModelType>
  isLoading: boolean
  onArchiveItem: (id: number) => void
}

export const TransportTypeTable: FC<TransportTableProps> = ({
  modelsTypes,
  isLoading,
  onArchiveItem,
}) => {
  if (isLoading) {
    return (
      <ContentContainer>
        <ListWrapper>
          <TableLoading />
        </ListWrapper>
      </ContentContainer>
    )
  }

  return (
    <ContentContainer>
      <ListWrapper>
        {modelsTypes?.map((modelType) => {
          return (
            <ModelTypeItem
              onArchiveItem={onArchiveItem}
              modelType={modelType}
            />
          )
        })}

        {modelsTypes?.length === 0 && <NoDataMessage />}
      </ListWrapper>
    </ContentContainer>
  )
}
